import { RootState } from '../store';

export const organization = (state: RootState) => state.organization;
export const orgId = (state: RootState) => state.organization.id;
export const orgLogo = (state: RootState) => state.organization.logo || '';
export const orgName = (state: RootState) => state.organization.name || '';
export const orgAllowAttachment = (state: RootState) => state.organization.allowAttachment;
export const orgAllowPhoto = (state: RootState) => state.organization.allowPhoto;
export const orgPhone = (state: RootState) => state.organization.phone || '';
